import { SET_TIMEZONE } from '../actions/timezone';

const parseTimezone = (tz: string) => {
  switch (tz) {
  case 'exchange':
    return 'Etc/UTC';
  default:
    return tz;
  }
};

export interface ITimezoneState {
  current?: string;
}

export const LS_TIMEZONE_KEY = 'kattana-simple.timezone';

const defaultTimezoneState = () => {
  if (window.localStorage) {
    const storedTimezone = window.localStorage.getItem(LS_TIMEZONE_KEY);
    if (storedTimezone) {
      return {
        current: parseTimezone(storedTimezone),
      };
    }
  }

  return {
    current: undefined,
  };
};

const networkReducer = (
  state: ITimezoneState = defaultTimezoneState(),
  action: { type: string; payload: string }
): ITimezoneState => {
  switch (action.type) {
  case SET_TIMEZONE:
    return {
      current: parseTimezone(action.payload),
    };
  default:
    return state;
  }
};

export default networkReducer;
